import { createContext } from "react";

import { TOrderDataContext } from "../types";

const OrderDataContext = createContext<TOrderDataContext | undefined>(undefined);
export default OrderDataContext;
